(() => {
  'use strict';
  const bar = document.getElementById('nde-regional-currency');
  if (!bar || window.ndeRegionalCurrencyLoaded) return;
  window.ndeRegionalCurrencyLoaded = true;
  const configuredUsdRate = Number(bar.dataset.usdRate);
  const rates = { PKR: 1, EUR: 290, GBP: 350, ZAR: 15, SAR: 65, AED: 70, USD: configuredUsdRate > 0 ? configuredUsdRate : 290 };
  const countries = { IE: 'EUR', GB: 'GBP', ZA: 'ZAR', SA: 'SAR', AE: 'AED' };
  const key = 'nde_display_country_override_v1';
  let status = null;
  const records = new WeakMap();
  const excluded = 'script, style, textarea, input, select, option, noscript, template, svg, math, [contenteditable], [data-no-currency-conversion], localization-form, price-range';
  const pending = new Set();
  const pattern = /(?:\bPKR\s*|\bRs\.?\s*|₨\s*)(\d[\d,]*(?:\.\d{1,2})?)(?:\s*PKR\b)?|(\d[\d,]*(?:\.\d{1,2})?)\s*(?:PKR\b|Rs\b\.?|₨)/gi;
  let currency = 'PKR';
  let preference = '';
  let detected = '';
  let scheduled = false;
  let detecting = null;
  try { const saved = localStorage.getItem(key); if (saved && /^[A-Z]{2}$/.test(saved)) preference = saved; } catch (_) {}
  const format = amount => currency + ' ' + (amount / rates[currency]).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function convertNode(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    let record = records.get(node);
    if (!record || node.nodeValue !== record.output) record = { source: node.nodeValue, output: node.nodeValue };
    pattern.lastIndex = 0;
    if (!pattern.test(record.source)) { records.delete(node); return; }
    pattern.lastIndex = 0;
    const output = currency === 'PKR' ? record.source : record.source.replace(pattern, (_, prefixValue, suffixValue) => format(Number((prefixValue || suffixValue).replaceAll(',', ''))));
    record.output = output;
    records.set(node, record);
    if (node.nodeValue !== output) node.nodeValue = output;
  }
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') schedule(mutation.target);
      else mutation.addedNodes.forEach(node => schedule(node));
    }
  });
  function render() {
    scheduled = false;
    observer.disconnect();
    const targets = pending.has(document.body) ? [document.body] : Array.from(pending);
    pending.clear();
    targets.forEach(root => {
      if (!root.isConnected) return;
      if (root.nodeType === Node.TEXT_NODE) { convertNode(root); return; }
      if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      let node;
      while ((node = walker.nextNode())) convertNode(node);
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  function schedule(root = document.body) {
    if (!root || (root.nodeType !== Node.TEXT_NODE && root.nodeType !== Node.ELEMENT_NODE)) return;
    const element = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
    if (!element || element.closest(excluded)) return;
    pending.add(root);
    if (!scheduled) { scheduled = true; requestAnimationFrame(render); }
  }
  function apply() {
    const country = preference || detected || bar.dataset.country || 'PK';
    currency = country === 'PK' ? 'PKR' : countries[country] || 'USD';
    document.querySelectorAll('footer localization-form').forEach(localization => {
      const buttonLabel = localization.querySelector('[data-nde-country-label]');
      const links = localization.querySelectorAll('a[data-value]');
      let countryName = '';
      links.forEach(link => {
        const current = link.dataset.value === country;
        if (current) {
          countryName = link.querySelector('.country')?.textContent.trim() || '';
          link.setAttribute('aria-current', 'true');
        } else link.removeAttribute('aria-current');
        const check = link.querySelector('span:not(.country):not(.localization-form__currency)');
        if (check) check.classList.toggle('visibility-hidden', !current);
      });
      if (buttonLabel && countryName) buttonLabel.textContent = countryName + ' | ' + currency;
    });
    if (!status) {
      const footer = document.querySelector('footer .footer__localization');
      if (footer) {
        status = document.createElement('small');
        status.setAttribute('data-no-currency-conversion', '');
        status.setAttribute('role', 'status');
        status.className = 'nde-currency-notice';
        footer.appendChild(status);
      }
    }
    if (status) {
      status.hidden = currency === 'PKR';
      status.textContent = currency === 'PKR' ? '' : 'Estimated prices in ' + currency + '. Checkout and payment in PKR.';
    }
    bar.dataset.displayCurrency = currency;
    schedule();
  }
  async function detect() {
    if (detecting) return detecting;
    detecting = (async () => {
      try {
        const cached = JSON.parse(sessionStorage.getItem('nde_display_country_v1') || 'null');
        if (cached && /^[A-Z]{2}$/.test(cached.country) && Date.now() - cached.time < 3600000) { detected = cached.country; return; }
      } catch (_) {}
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        const country = data.detected_values?.country?.handle;
        if (typeof country === 'string' && /^[A-Z]{2}$/.test(country)) {
          detected = country;
          try { sessionStorage.setItem('nde_display_country_v1', JSON.stringify({country, time: Date.now()})); } catch (_) {}
        }
      } catch (_) {} finally { clearTimeout(timeout); }
    })();
    await detecting;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('footer localization-form a[data-value]');
    if (!link) return;
    const form = link.closest('form');
    if (!form || !form.querySelector('input[name="country_code"]')) return;
    const country = link.dataset.value;
    if (!/^[A-Z]{2}$/.test(country)) return;
    preference = country;
    try { localStorage.setItem(key, country); } catch (_) {}
    apply();
  }, true);
  window.addEventListener('pageshow', () => schedule());
  document.addEventListener('shopify:section:load', event => schedule(event.target));
  apply();
  if (!preference) detect().then(apply);
})();
